import api from "@utils/api";

const ORGANIZATION = JSON.parse(sessionStorage.getItem("organization"));
export const getUsers = () =>
  api.get(
    `/user_management/organizacion/${ORGANIZATION.organizacion_id}?page=1&per_page=50`);
export const getUserById = (id) => api.get(`/user_management/${id}`);
// En `users.username` el backend puede tener un valor distinto del identificador
// con el que se hizo login (unas veces el correo, otras el nombre completo), asi
// que preferimos el username canonico que devuelve /login y solo caemos al valor
// tecleado si no esta disponible.
const getStoredUserName = () => {
  try {
    const storedUser = JSON.parse(sessionStorage.getItem("user"));
    if (storedUser?.username) return storedUser.username;
  } catch {
    // sessionStorage["user"] ausente o corrupto: usamos el fallback de abajo.
  }
  return sessionStorage.getItem("username");
};

export const getPlacesByUserName = () =>
  getPlacesByUserNameParam(getStoredUserName());
export const createUser = (user) => api.post("/user_management/register", user);
export const createAdminUser = (user) => api.post("/admin_user/", user);
export const updateUser = async (id, user) => {
  const response = await api.put(`/user_management/${id}`, user);
  return response.data;
};
export const getUserByPlaceId = (id) => api.get(`/user_management/place/${id}/non-admin-users`);

export const getAdminUsers = () =>
  api.get(
    `/admin_user/organizacion/${ORGANIZATION.organizacion_id}?page=1&per_page=50`
  );
export const getAdminUsersByPlaceId = (id) => api.get(`/user_management/place/${id}/admin-users`);
export const updateAdminUser = async (id, user) => {
  const response = await api.put(`/admin_user/${id}`, user);
  return response.data;
};
export const deleteUser = (id) => api.delete(`/user_management/${id}`);
export const deleteAdminUser = (id) => api.delete(`/admin_user/${id}`);
export const getPlacesByUserNameParam = (username) =>
  api.get(`/user_management/username/${encodeURIComponent(username ?? "")}`);

export const searchUsers = async (term) => {
  const response = await api.get(`/user_management/organizacion/${ORGANIZATION.organizacion_id}?search=${term}&amp;page=1&amp;per_page=10`);
  return response.data;
};
